import React, { createContext, useContext, useState, useCallback } from 'react';
import DakhlaButterflyLoader from '../components/common/DakhlaButterflyLoader';

const LoadingContext = createContext();

export const useGlobalLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useGlobalLoading must be used within a LoadingProvider');
  }
  return context;
};

export const LoadingProvider = ({ children }) => {
  const [loadingState, setLoadingState] = useState({
    active: false,
    text: 'Loading...'
  });

  const showLoader = useCallback((text = 'Loading...') => {
    setLoadingState({ active: true, text });
  }, []);

  const hideLoader = useCallback(() => {
    setLoadingState(prev => ({ ...prev, active: false }));
  }, []);

  const updateLoaderText = useCallback((text) => {
    setLoadingState(prev => ({ ...prev, text }));
  }, []);

  return (
    <LoadingContext.Provider value={{ showLoader, hideLoader, updateLoaderText, isLoading: loadingState.active }}>
      {children}
      {/* Global persistent loader overlay that stays mounted to prevent animation restart flickers */}
      {loadingState.active && (
        <DakhlaButterflyLoader text={loadingState.text} fullScreen={true} />
      )}
    </LoadingContext.Provider>
  );
};
